<template>
<div id="app" class="home page-template-default wp-custom-logo sticky-enabled no-sidebar separate-containers">
  <HeadNav selectedLanguage="en" page="gb" :gotodownload="goToDownload" :apk="apk" />

  <main id="maincontent" class="home-main">
    <section class="hero-section section-band">
      <div class="section-inner hero-shell">
        <h1>Download GB WhatsApp APK Latest Version</h1>
        <div class="hero-grid">
          <div class="hero-media">
            <img src="@/assets/gbwhatsapp-hero.webp" alt="GB WhatsApp APK for Android preview">
            <button class="primary-download" @click="goToDownload">
              <img src="@/assets/download-line.svg" alt="" class="download-icon">
              Download GB WhatsApp APK v18.80
            </button>
          </div>
          <div class="hero-copy">
            <p>
              <strong>GB WhatsApp v18.80</strong> is the latest version listed on this site. Use the download button below to get the APK and check the file information before installing it on your Android device.
            </p>
            <ul class="hero-facts-list">
              <li v-for="item in heroFacts" :key="item.label">
                <strong>{{ item.label }}:</strong> {{ item.value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <article class="article-shell">
      <section class="content-section">
        <p>
          Before installing, make sure your device has enough storage and back up important WhatsApp chats and media. GB WhatsApp is not an official WhatsApp application, so understand the differences and risks before switching from the official app.
        </p>
      </section>

      <section class="content-section">
        <h2>GB WhatsApp App Information</h2>
        <p>Here is the basic information you may want to check before downloading the APK.</p>
        <div class="info-table">
          <table>
            <tbody>
              <tr v-for="item in appInfo" :key="item.label">
                <th>{{ item.label }}</th>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          The version number and APK details can change when a new build becomes available. If you are using an older release, compare its features and compatibility before updating.
        </p>
        <figure class="wide-image">
          <img src="@/assets/gbwhatsapp-app-info.webp" alt="GB WhatsApp app information and Android APK details">
        </figure>
      </section>

      <section class="content-section install-guide">
        <h2>How to Download and Install GB WhatsApp App</h2>
        <p class="install-intro">
          Installing an APK is slightly different from installing an app through Google Play. If this is your first time using a third-party Android APK, follow the steps below.
        </p>
        <ol class="install-steps">
          <li v-for="(step, index) in installSteps" :key="step.title">
            <span class="step-index">{{ index + 1 }}</span>
            <div class="step-content">
              <h3>{{ step.title }}</h3>
              <p>{{ step.text }}</p>
            </div>
          </li>
        </ol>
        <p class="notice">
          <strong>Important:</strong> Do not delete your previous WhatsApp data immediately. Make sure your important conversations, photos, videos, and documents are available first.
        </p>
      </section>

      <section class="content-section">
        <h2>What Is GB WhatsApp?</h2>
        <p>
          <a href="/">GB WhatsApp</a> is a modified Android client based around the WhatsApp messaging experience. Unlike the official application, modified builds typically add extra options for privacy, customization, messaging, and media.
        </p>
        <p>
          People usually look for GB WhatsApp because they want more control over how the app looks or what activity other contacts can see.
        </p>
        <p>
          For example, users may want to hide their online status, change themes, customize fonts, download status updates, or use additional messaging controls.
        </p>
        <p>
          There is an important trade-off, though. GB WhatsApp is <strong>not developed or supported by WhatsApp</strong>. WhatsApp considers modified clients unofficial and warns users about potential security, privacy, and account-access risks.
        </p>
        <p>
          So GB WhatsApp is best understood as a third-party alternative for Android users who want additional controls, rather than an official replacement for WhatsApp.
        </p>
      </section>

      <section class="content-section feature-section">
        <h2>GB WhatsApp Features You Can Actually Use</h2>
        <p class="feature-intro">
          The exact features depend on the build you install, but GB WhatsApp is mainly known for giving users more control over privacy and customization.
        </p>
        <div class="feature-grid">
          <section v-for="feature in features" :key="feature.title" class="feature-card">
            <div class="feature-card-head">
              <span class="feature-icon">
                <img :src="feature.icon" alt="">
              </span>
              <h3>{{ feature.title }}</h3>
            </div>
            <p class="feature-text">{{ feature.text }}</p>
            <p v-if="feature.detail" class="feature-detail">{{ feature.detail }}</p>
          </section>
        </div>
        <p class="feature-footnote">
          Because these are third-party builds, features can change between versions. A feature available in one release may be renamed, moved, changed, or removed in another.
        </p>
      </section>

      <section class="content-section usage-guide-section">
        <h2>How to Use Popular GB WhatsApp Features</h2>
        <p class="usage-intro">Downloading GB WhatsApp is only the beginning. Many users install it because they want to change one particular setting.</p>
        <div class="usage-strip-list">
          <section v-for="item in usageTips" :key="item.title" class="usage-strip-item">
            <h3>{{ item.title }}</h3>
            <p v-if="item.html" v-html="item.text"></p>
            <p v-else>{{ item.text }}</p>
          </section>
        </div>
        <p class="usage-footnote">Menu names can differ between releases, so don't worry if your settings are located somewhere slightly different.</p>
      </section>

      <section class="content-section">
        <h2>GB WhatsApp vs Official WhatsApp</h2>
        <p>
          The biggest difference between the two apps is not simply the number of features. It is the difference between using an unofficial modified client and an application officially developed and supported by WhatsApp.
        </p>
        <div class="comparison-table">
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th>GB WhatsApp</th>
                <th>Official WhatsApp</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in comparisonRows" :key="row.feature">
                <th>{{ row.feature }}</th>
                <td>{{ row.gb }}</td>
                <td>{{ row.official }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          If your priority is official support, account stability, and predictable updates, the official WhatsApp app is the straightforward choice.
        </p>
        <p>
          If customization and additional privacy controls matter more to you, GB WhatsApp may appear more attractive. The important thing is to understand that those extra features come with additional risks.
        </p>
      </section>

      <section class="content-section">
        <h2>Why Do People Choose GB WhatsApp?</h2>
        <p>
          GB WhatsApp attracts users for several practical reasons rather than one single feature.
        </p>
        <p>
          Some users want more control over their online visibility. Others care about themes, fonts, chat customization, status tools, or additional messaging options.
        </p>
        <p>
          The main appeal can be summarized as <strong>more control and more customization</strong>.
        </p>
        <p>
          However, these benefits should be considered alongside the limitations. GB WhatsApp does not have the same official support as WhatsApp, and using an unofficial client can create account and security concerns.
        </p>
        <p>
          For that reason, the right choice depends on what matters most to you. If additional customization is important, GB WhatsApp offers more options. If official support and account security are your priorities, the standard WhatsApp app remains the safer choice.
        </p>
      </section>

      <section class="content-section">
        <h2>Is GB WhatsApp Safe to Use?</h2>
        <p>GB WhatsApp should not be described as completely safe simply because an APK installs successfully or works without problems.</p>
        <p>There are several different risks to consider.</p>
        <p><strong>File safety:</strong> A third-party APK can potentially be modified or repackaged, especially when obtained from an unknown source.</p>
        <p><strong>Privacy:</strong> Unlike the official WhatsApp app, a modified client is not controlled or supported by WhatsApp, so its security and privacy practices cannot be treated as equivalent.</p>
        <p><strong>Account safety:</strong> WhatsApp does not officially support modified clients and may restrict accounts that use them.</p>
        <p>
          This means "safe" depends on what you are measuring. An APK might pass a malware scan while the account is still exposed to the risks associated with using an unofficial WhatsApp client.
        </p>
        <p>
          For that reason, check the APK information before installing, use a reputable security scanner, keep important data backed up, and do not treat claims such as <strong>"100% safe"</strong> or <strong>"guaranteed anti-ban"</strong> as guarantees.
        </p>
      </section>

      <section class="content-section">
        <h2>Can GB WhatsApp Get Your Account Banned?</h2>
        <p><strong>Yes, there is a real risk of account restriction.</strong></p>
        <p>
          WhatsApp does not officially support GB WhatsApp or other modified WhatsApp clients. WhatsApp's guidance states that users of unofficial applications may receive temporary bans and may need to switch to the official application.
        </p>
        <p>
          This is also why the term <strong>Anti-Ban</strong> should be treated carefully. A modified app cannot guarantee that WhatsApp will never restrict an account.
        </p>
        <p>
          If you want to reduce unnecessary account problems, avoid behavior that can trigger WhatsApp restrictions, such as spam, bulk messaging, or automated activity.
        </p>
        <p>
          If WhatsApp restricts your account, use the official review or support process provided by WhatsApp rather than relying on a third-party service claiming that it can remove the ban.
        </p>
      </section>

      <section class="content-section">
        <h2>How to Transfer WhatsApp Chats to GB WhatsApp</h2>
        <p>
          Your chat history is often the biggest concern when switching from official WhatsApp to GB WhatsApp.
        </p>
        <p>
          The safest approach is to prepare your data before changing applications.
        </p>
        <p>
          Start by backing up your important conversations and media. Keep the original backup and existing data until you have checked the new installation.
        </p>
        <p>
          After installing GB WhatsApp, follow the restore or migration process supported by your particular build. Once setup is complete, check several important conversations, photos, videos, and documents.
        </p>
        <p>
          Do not assume that every official WhatsApp backup will automatically restore inside a modified client. Compatibility can vary, and WhatsApp does not guarantee successful chat transfer between unofficial applications and the official app.
        </p>
        <p>
          If your chats are especially important, keep separate copies of irreplaceable media and documents before switching.
        </p>
      </section>

      <section class="content-section">
        <h2>What Is New in GB WhatsApp v18.80?</h2>
        <p>
          GB WhatsApp v18.80 is the current version listed on this site.
        </p>
        <p>
          Recent third-party release information for this build highlights changes involving messaging, media controls, interface behavior, backups, and stability improvements. Depending on the specific build, users may also find updated options for message editing, media sharing, message pinning, and other everyday controls.
        </p>
        <p>
          Because GB WhatsApp does not publish an official WhatsApp changelog, release information can vary between different builds and distributors.
        </p>
        <p>
          If you are currently using v18.70 or another older release, compare the actual changes before updating. A newer version is not automatically better for every device or user.
        </p>
      </section>

      <section class="content-section">
        <h2>GB WhatsApp Old Versions</h2>
        <p>
          Sometimes the newest version isn't the version a user wants.
        </p>
        <p>
          You may prefer an older release because its interface is familiar, a particular feature worked differently, or the previous build performed better on your device.
        </p>
        <p>Here are some of the versions users may look for:</p>
        <div class="info-table">
          <table>
            <thead>
              <tr>
                <th>Version</th>
                <th>Best For</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="version in oldVersions" :key="version.version">
                <td>{{ version.version }}</td>
                <td>{{ version.bestFor }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Older APKs also have disadvantages. They may lack newer fixes, work poorly with current Android versions, or contain bugs that were addressed in later releases.
        </p>
        <p>
          If you decide to use an old version, check its Android compatibility and keep a backup before changing your current installation.
        </p>
      </section>

      <section class="content-section troubleshooting-section">
        <h2>GB WhatsApp Troubleshooting</h2>
        <p class="troubleshooting-intro">Even when the APK is installed correctly, you may run into problems during setup or everyday use.</p>
        <div class="usage-strip-list">
          <section v-for="item in troubleshooting" :key="item.title" class="usage-strip-item">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </section>
        </div>
      </section>

      <section class="content-section">
        <h2>GB WhatsApp Alternatives</h2>
        <p>
          GB WhatsApp isn't the only option available to Android users.
        </p>
        <p>
          Some people compare it with other modified WhatsApp clients such as FM WhatsApp or YOWhatsApp because they are also associated with additional customization and privacy features.
        </p>
        <p>
          The important point is that moving from one modified WhatsApp client to another does not make it an official WhatsApp experience. Similar security, privacy, update, and account-related considerations still apply.
        </p>
        <p>If you want:</p>
        <p><strong>Official support and maximum account stability:</strong> use WhatsApp.</p>
        <p><strong>More customization and additional controls:</strong> GB WhatsApp may be worth considering if you understand the trade-offs.</p>
        <p><strong>A different modified experience:</strong> compare alternatives based on the exact features you need rather than relying on "anti-ban" or "100% safe" claims.</p>
      </section>

      <section class="content-section faq-section">
        <h2>Frequently Asked Questions About GB WhatsApp</h2>
        <div class="faq-accordion">
          <div
            v-for="(item, index) in faqs"
            :key="item.question"
            class="faq-item"
            :class="{ 'is-open': isFaqOpen(index) }"
          >
            <button
              type="button"
              class="faq-question"
              :aria-expanded="isFaqOpen(index)"
              @click="toggleFaq(index)"
            >
              <span class="faq-question-text">{{ item.question }}</span>
              <span class="faq-icon" aria-hidden="true"></span>
            </button>
            <div class="faq-answer">
              <p>{{ item.answer }}</p>
            </div>
          </div>
        </div>
      </section>

      <section class="content-section final-section">
        <h2>Final Thoughts</h2>
        <p>
          GB WhatsApp is mainly aimed at Android users who want more customization, privacy controls, and messaging options than the standard WhatsApp experience provides.
        </p>
        <p>
          Before downloading it, however, consider the complete picture. You should know which version you are installing, how to back up and transfer your chats, what features you actually need, and what risks come with using an unofficial client.
        </p>
        <p>
          If those trade-offs are acceptable to you, you can check the latest APK information above and choose the version that best fits your device. If official support, security assurances, and account stability matter more, the official WhatsApp application remains the better option.
        </p>
      </section>
    </article>
  </main>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import 'swiper/css/swiper.css';

const DEFAULT_DOMAIN = 'gbwasap.org';
const DEFAULT_APP_NAME = 'GB_gbwasap.org';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
      openFaqIndexes: [],
      heroFacts: [
        { label: 'Latest Version', value: 'v18.80' },
        { label: 'Platform', value: 'Android' },
        { label: 'Minimum Android', value: 'Android 5.0+' },
        { label: 'File Format', value: 'APK' },
        { label: 'File Size', value: '80MB' },
        { label: 'App Type', value: 'Third-party modified WhatsApp client' },
      ],
      appInfo: [
        { label: 'App Name', value: 'GB WhatsApp' },
        { label: 'Latest Version', value: 'v18.80' },
        { label: 'Platform', value: 'Android' },
        { label: 'Android Requirement', value: 'Android 5.0+' },
        { label: 'File Type', value: 'APK' },
        { label: 'App Category', value: 'Communication' },
        { label: 'Developer', value: 'Third-party developer' },
        { label: 'Official WhatsApp App', value: 'No' },
        { label: 'License', value: 'Free to download' },
      ],
      installSteps: [
        {
          title: 'Back Up Your WhatsApp Data',
          text: 'Before changing apps, create a backup of important chats and media. Keep your existing data until you have confirmed that everything you need is available after the switch.',
        },
        {
          title: 'Download the GB WhatsApp APK',
          text: 'Download the version you want and check its version number and file information before opening it.',
        },
        {
          title: 'Allow APK Installation',
          text: 'Android may ask you to allow your browser or file manager to install applications from that source. The exact setting can vary depending on your Android version and phone manufacturer.',
        },
        {
          title: 'Install the APK',
          text: 'Open the downloaded APK and follow the Android installation prompts. If the installation fails, check your available storage, Android version, and whether another WhatsApp installation is causing a package conflict.',
        },
        {
          title: 'Verify Your Phone Number',
          text: 'Open GB WhatsApp and enter your phone number. Complete the verification process using the SMS or call option available on your device.',
        },
        {
          title: 'Restore Your Chats',
          text: 'If the build supports the backup or migration method you are using, follow the restore instructions and check your chats and media after setup.',
        },
      ],
      features: [
        {
          title: 'Privacy Features',
          icon: require('@/assets/icons/feature-privacy.svg'),
          text: 'GB WhatsApp commonly includes additional controls for online status, last seen, blue ticks, typing indicators, and other activity information.',
          detail: 'These settings are useful if you want to use WhatsApp without making every activity visible to your contacts.',
        },
        {
          title: 'Custom Themes and Interface',
          icon: require('@/assets/icons/feature-theme.svg'),
          text: 'The standard WhatsApp interface offers relatively limited customization. GB WhatsApp builds generally provide more options for themes, fonts, wallpapers, colors, icons, and chat appearance.',
          detail: 'You can use these settings to give individual conversations or the entire app a different look.',
        },
        {
          title: 'Messaging Options',
          icon: require('@/assets/icons/feature-message.svg'),
          text: 'Depending on the version, GB WhatsApp may include auto-reply, message controls, larger media-sharing options, and other features designed to give users more flexibility when communicating.',
        },
        {
          title: 'Status and Media Tools',
          icon: require('@/assets/icons/feature-media.svg'),
          text: 'Some builds also provide additional controls for WhatsApp Status and media, including options for saving status content and managing how media is displayed or shared.',
        },
      ],
      usageTips: [
        {
          title: 'Hide Online Status',
          text: 'Open the privacy settings in GB WhatsApp and look for the option controlling online visibility. Choose the available setting that prevents your online activity from being shown to other contacts.',
        },
        {
          title: 'Freeze Last Seen',
          html: true,
          text: 'If your version includes <strong>Freeze Last Seen</strong>, open the privacy settings and enable the option. Your displayed last-seen information can then remain unchanged while you continue using the app.',
        },
        {
          title: 'Hide Blue Ticks',
          text: 'Go to the privacy settings and look for the read-receipt or blue-tick controls. Select the option that matches how you want read information to appear to your contacts.',
        },
        {
          title: 'Hide Typing Status',
          text: 'Look for the typing indicator setting under the privacy or privacy-related controls. If supported by your build, enabling it can prevent the usual typing notification from appearing.',
        },
        {
          title: 'Change GB WhatsApp Themes',
          text: 'Open the Themes or customization section and choose a theme available in your version. Some builds also allow users to import or download compatible themes.',
        },
      ],
      comparisonRows: [
        {
          feature: 'Custom themes',
          gb: 'More options',
          official: 'Limited',
        },
        {
          feature: 'Privacy customization',
          gb: 'More controls',
          official: 'Standard controls',
        },
        {
          feature: 'Interface customization',
          gb: 'Extensive',
          official: 'More limited',
        },
        {
          feature: 'Official support',
          gb: 'No',
          official: 'Yes',
        },
        {
          feature: 'Google Play distribution',
          gb: 'No',
          official: 'Yes',
        },
        {
          feature: 'Official security support',
          gb: 'No',
          official: 'Yes',
        },
        {
          feature: 'Account restriction risk',
          gb: 'Higher',
          official: 'Lower',
        },
        {
          feature: 'Updates',
          gb: 'Third-party builds',
          official: 'Official updates',
        },
      ],
      oldVersions: [
        { version: 'v18.80', bestFor: 'Users looking for the latest release' },
        { version: 'v18.70', bestFor: 'Users who prefer the previous build' },
        { version: 'Older versions', bestFor: 'Compatibility or previous feature preferences' },
      ],
      troubleshooting: [
        {
          title: "GB WhatsApp Won't Install",
          text: 'Check your Android version and available storage first. If another WhatsApp package is installed, the two packages may conflict depending on the build.',
        },
        {
          title: "Verification Code Isn't Arriving",
          text: 'Check your phone signal, confirm that the number is correct, and wait before requesting another code. Repeated verification requests can sometimes cause additional delays.',
        },
        {
          title: 'GB WhatsApp Keeps Crashing',
          text: 'Make sure the build is compatible with your Android version and that the app has enough storage and required permissions. If the problem started immediately after an update, an earlier compatible version may work better.',
        },
        {
          title: 'Chats Cannot Be Restored',
          text: 'Backup compatibility can vary between official WhatsApp and modified clients. Keep your original backup and check whether your particular GB WhatsApp build supports the restore method you are trying to use.',
        },
        {
          title: 'Calls Are Not Working',
          text: 'Check microphone and camera permissions, your internet connection, and whether the problem occurs with both Wi-Fi and mobile data. If only GB WhatsApp has the problem, the issue may be related to the particular build.',
        },
      ],
      faqs: [
        {
          question: 'Can I use my existing WhatsApp number with GB WhatsApp?',
          answer: 'GB WhatsApp can use a phone number for account verification, but using an unofficial client carries a risk of account restriction. Consider the importance of the number before switching.',
        },
        {
          question: 'Can I switch back to official WhatsApp?',
          answer: 'Yes, but chat transfer is not guaranteed when moving between an unofficial client and official WhatsApp. Keep your original backup and important media before switching.',
        },
        {
          question: 'Will I lose my chats when installing GB WhatsApp?',
          answer: 'Not necessarily, but you should never assume that all chats and media will transfer automatically. Back up your data first and verify the result after installation.',
        },
        {
          question: 'Can I install GB WhatsApp on iPhone?',
          answer: 'GB WhatsApp is distributed as an Android APK. There is no official GB WhatsApp APK installation method for iPhone.',
        },
        {
          question: 'Can I use an older GB WhatsApp version?',
          answer: 'Yes, if you can obtain a compatible build, but older releases may have fewer features, compatibility issues, or unresolved bugs. Check the version requirements before installing one.',
        },
        {
          question: 'What should I do if WhatsApp restricts my account?',
          answer: 'Follow the official WhatsApp review or support process shown for your account. Avoid services that claim they can guarantee removal of an account restriction.',
        },
        {
          question: 'Is GB WhatsApp officially affiliated with WhatsApp?',
          answer: 'No. GB WhatsApp is a third-party modified client and is not an official WhatsApp application.',
        },
      ],
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || DEFAULT_DOMAIN,
          appName: appname || DEFAULT_APP_NAME,
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    goToDownload() {
      this.$router.push({
        name: 'en-download',
      });
    },
    toggleFaq(index) {
      if (this.openFaqIndexes.includes(index)) {
        this.openFaqIndexes = this.openFaqIndexes.filter((item) => item !== index);
      } else {
        this.openFaqIndexes = [...this.openFaqIndexes, index];
      }
    },
    isFaqOpen(index) {
      return this.openFaqIndexes.includes(index);
    },
  },
};
</script>

<style lang="scss" scoped>
.home-main {
  background: #f6f8f7;
  color: #24312c;
}

.section-band {
  width: 100%;
}

.section-inner,
.article-shell {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding-left: 32px;
  padding-right: 32px;
  box-sizing: border-box;
}

.hero-section {
  background:
    radial-gradient(circle at 8% 15%, rgba(255, 199, 83, 0.18), transparent 28%),
    linear-gradient(135deg, #f7fff9 0%, #e8f5ef 52%, #fff7e1 100%);
  border-bottom: 1px solid #dbe8e1;
}

.hero-shell {
  padding: 48px 0 40px;
}

.hero-shell h1 {
  margin: 0 0 28px;
  text-align: center;
}

.hero-grid {
  display: grid;
  grid-template-columns: minmax(260px, 360px) minmax(0, 1fr);
  gap: 28px 34px;
  align-items: flex-start;
}

.hero-media {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  width: 100%;
  max-width: 360px;
}

.hero-media img {
  display: block;
  width: 100%;
  max-width: 280px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 18px 45px rgba(10, 72, 50, 0.16);
}

.hero-copy p {
  margin-top: 0;
}

.hero-facts-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.hero-facts-list li {
  margin: 0 0 10px;
  color: #24312c;
  font-size: 17px;
  line-height: 1.65;
}

.hero-facts-list li:last-child {
  margin-bottom: 0;
}

.hero-facts-list strong {
  color: #10261d;
  font-weight: 800;
}

.wide-image {
  width: min(720px, 85%);
  margin: 0 auto 16px;
}

.wide-image img {
  display: block;
  width: 100%;
  margin: 0 auto;
  border-radius: 8px;
}

.two-column-section img {
  display: block;
  width: 100%;
  border-radius: 8px;
}

.eyebrow {
  margin: 0 0 10px;
  color: #107b59;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
}

h1 {
  margin: 0 0 18px;
  color: #10261d;
  font-size: 46px;
  font-weight: 800;
  line-height: 1.1;
}

.content-section > h2,
.install-guide > h2 {
  text-align: center;
}

h2 {
  margin: 0 0 14px;
  color: #15372a;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
}

h3 {
  margin: 0 0 8px;
  color: #1b3a2e;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.3;
}

p {
  margin: 0 0 16px;
  color: #40544c;
  font-size: 17px;
  line-height: 1.72;
}

.content-section a {
  color: #107b59;
  font-weight: 700;
  text-decoration: none;
}

.content-section a:hover {
  text-decoration: underline;
}

.primary-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 360px;
  min-height: 52px;
  padding: 0 26px;
  border: 0;
  border-radius: 8px;
  background: #128c62;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(18, 140, 98, 0.24);
}

.primary-download .download-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
}

.primary-download:hover {
  background: #0e7451;
}

.article-shell {
  padding: 34px 0 60px;
}

.content-section {
  padding: 28px 0;
  border-bottom: 1px solid #dde8e2;
}

.content-section:last-child {
  border-bottom: 0;
}

.info-table,
.comparison-table {
  overflow-x: auto;
  margin: 14px 0 16px;
  border: 1px solid #d6e4dd;
  border-radius: 6px;
  background: #fff;
  font-size: 14px;
}

.info-table table,
.comparison-table table {
  width: 100%;
  border-collapse: collapse;
}

.info-table th,
.info-table td,
.comparison-table th,
.comparison-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #e8eeeb;
  color: #3d4f48;
  text-align: left;
  vertical-align: middle;
  font-size: 14px;
  line-height: 1.45;
}

.info-table tr:last-child th,
.info-table tr:last-child td,
.comparison-table tr:last-child th,
.comparison-table tr:last-child td {
  border-bottom: 0;
}

.info-table th {
  width: 32%;
  background: #eef7f2;
  color: #15372a;
  font-size: 13px;
  font-weight: 700;
}

.comparison-table thead th {
  background: #eef7f2;
  color: #15372a;
  font-size: 13px;
  font-weight: 700;
}

.comparison-table tbody th {
  width: 28%;
  background: #f6faf8;
  color: #15372a;
  font-size: 13px;
  font-weight: 700;
}

.install-guide {
  padding: 26px 28px;
  border: 1px solid #dbe8e1;
  border-radius: 12px;
  background: linear-gradient(180deg, #fcfffd 0%, #f3f8f5 100%);
}

.install-guide h2 {
  margin-bottom: 12px;
}

.install-intro {
  margin-bottom: 18px;
  color: #4f625b;
  font-size: 16px;
  line-height: 1.65;
}

.install-steps {
  display: grid;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.install-steps li {
  display: grid;
  grid-template-columns: 34px 1fr;
  gap: 14px;
  align-items: start;
  padding: 14px 16px;
  border: 1px solid #e2ebe6;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.step-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #15986d 0%, #0f7453 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
}

.step-content h3 {
  margin: 0 0 6px;
  color: #15372a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.35;
}

.step-content p {
  margin: 0;
  color: #4d5f58;
  font-size: 14px;
  line-height: 1.55;
}

.install-guide .notice {
  margin-top: 16px;
  margin-bottom: 0;
  padding: 12px 14px;
  border-left: 4px solid #d99118;
  border-radius: 0 8px 8px 0;
  background: #fff8e8;
  color: #574018;
  font-size: 14px;
  line-height: 1.55;
}

.two-column-section {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(280px, 0.95fr);
  gap: 34px;
  align-items: center;
}

.feature-section .feature-intro {
  margin-bottom: 16px;
  color: #4f625b;
  font-size: 16px;
  line-height: 1.65;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 16px;
}

.feature-card {
  min-height: auto;
  padding: 16px 18px;
  border: 1px solid #dbe8e1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.feature-card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #edf7f1;
}

.feature-icon img {
  width: 22px;
  height: 22px;
}

.feature-card h3 {
  margin: 0;
  color: #15372a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.35;
}

.feature-text,
.feature-detail {
  margin: 0;
  color: #4d5f58;
  font-size: 14px;
  line-height: 1.55;
}

.feature-detail {
  margin-top: 8px;
  color: #5d6f68;
  font-size: 13px;
}

.feature-footnote {
  margin-top: 14px;
  margin-bottom: 0;
  color: #5d6f68;
  font-size: 14px;
  line-height: 1.55;
}

.usage-guide-section .usage-intro {
  margin-bottom: 14px;
  color: #4f625b;
  font-size: 16px;
  line-height: 1.65;
}

.usage-strip-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-top: 14px;
}

.usage-strip-item {
  padding: 14px 16px;
  border: 1px solid #e2ebe6;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.usage-strip-item h3 {
  margin: 0 0 6px;
  color: #15372a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.35;
}

.usage-strip-item p {
  margin: 0;
  color: #4d5f58;
  font-size: 14px;
  line-height: 1.55;
}

.usage-footnote {
  margin-top: 14px;
  margin-bottom: 0;
  color: #5d6f68;
  font-size: 14px;
  line-height: 1.55;
}

.troubleshooting-section .troubleshooting-intro {
  margin-bottom: 14px;
  color: #4f625b;
  font-size: 16px;
  line-height: 1.65;
}

.usage-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 18px;
}

.faq-accordion {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.faq-item {
  overflow: hidden;
  border: 1px solid #dbe8e1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px 18px;
  border: 0;
  background: transparent;
  color: #15372a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
  text-align: left;
  cursor: pointer;
}

.faq-question-text {
  flex: 1;
}

.faq-icon {
  position: relative;
  flex-shrink: 0;
  width: 12px;
  height: 12px;
}

.faq-icon::before,
.faq-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  background: #15372a;
  transform: translate(-50%, -50%);
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.faq-icon::before {
  width: 12px;
  height: 2px;
}

.faq-icon::after {
  width: 2px;
  height: 12px;
}

.faq-item.is-open .faq-icon::after {
  transform: translate(-50%, -50%) scaleY(0);
  opacity: 0;
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.28s ease;
}

.faq-item.is-open .faq-answer {
  max-height: 240px;
}

.faq-answer p {
  margin: 0;
  padding: 0 18px 16px;
  color: #4d5f58;
  font-size: 14px;
  line-height: 1.6;
}

ul {
  margin: 0 0 16px 20px !important;
}

li {
  margin-bottom: 10px;
  color: #40544c;
  line-height: 1.66;
}

.final-section {
  padding-bottom: 10px;
}

@media (max-width: 860px) {
  .hero-grid,
  .two-column-section,
  .feature-grid {
    grid-template-columns: 1fr;
  }

  .feature-card {
    padding: 14px 16px;
  }

  .feature-card h3 {
    font-size: 15px;
  }

  .feature-text,
  .feature-footnote {
    font-size: 13px;
  }

  .feature-detail {
    font-size: 12px;
  }

  .hero-shell {
    padding-top: 34px;
  }

  .hero-grid {
    gap: 24px;
  }

  .hero-media {
    max-width: 336px;
    margin: 0 auto;
  }

  h1 {
    font-size: 36px !important;
  }

  h2 {
    font-size: 26px !important;
  }
}

@media (max-width: 520px) {
  .section-inner,
  .article-shell {
    padding-left: 20px;
    padding-right: 20px;
  }

  .install-guide {
    padding: 20px 18px;
  }

  .install-steps li {
    grid-template-columns: 30px 1fr;
    gap: 12px;
    padding: 12px 14px;
  }

  .step-index {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }

  .step-content h3 {
    font-size: 15px;
  }

  .step-content p,
  .install-guide .notice {
    font-size: 13px;
  }

  .faq-question {
    padding: 14px 16px;
    font-size: 15px;
  }

  .faq-answer p {
    padding: 0 16px 14px;
    font-size: 13px;
  }

  .primary-download {
    width: 100%;
    padding: 0 12px;
    font-size: 14px;
  }

  .wide-image {
    width: min(100%, 92%);
  }

  .info-table th,
  .info-table td,
  .comparison-table th,
  .comparison-table td {
    padding: 7px 10px;
    font-size: 13px;
    line-height: 1.4;
  }
}
</style>
